import React, { useState, useEffect, Fragment } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getCollectZoneList, getCarList, getDriverList } from "../../crud/search.crud"
import moment from 'moment';
import { changeContractSettlement, contractDetailResponse, getCollectionSettlementList, postMyContract, tradeHistoryCall } from "../../crud/auth.crud"
import Util from "pages/Dashboard/Common/Util";
import _ from "lodash";

import loading from "../../assets/images/loading.gif";
import Modal from "components/RopikCustom/Modal_v2";
import SelectBox from "components/RopikCustom/SelectBox";
import { deleteClientData, getContractCompanyForTreatmentList, updateContractDataForTreatment } from "crud/contact.crud";
import * as XLSX from 'xlsx';

const initSearchCondition = {
  companyName: '',
  companyNumber: '',
}

const companyType = {
  single: '일반배출자',
  report: '배출신고자',
  many: '다량 배출자',
  multi: '대수(통합) 배출자',
}

const CorrespondentManagementTreatment = () => {

  const selector = useSelector(state => state)
  const history = useHistory()
  const code = useSelector((state) => state.Data?.code[0] || [])

  const [carData, setCarData] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group.id)
  const [isLoading, setIsLoading] = useState(false);
  const [searchCondition, setSearchCondition] = useState(initSearchCondition)
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [modalShow, setModalShow] = useState({
    edit: false,
  })
  const [excelFile, setExcelFile] = useState([])
  const [onUpload, setOnUpload] = useState(false);
  const [isListEnd, setIsListEnd] = useState(false);
  const [listCount, setListCount] = useState(0)
  const [page, setPage] = useState(1)
  const [correspondentSize, setCorrespondentSize] = useState([])
  const [inputItem, setInputItem] = useState({})

  const changeInputCondition = (key, value) => {
    setInputItem(prev => ({...prev, [key]: value}))
  }

  const modalOpen = (key) => {
    setModalShow(prev => ({...prev, [key]: true}))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({...prev, [key]: false}))
  }

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const scrollPosition = window.scrollY || document.documentElement.scrollTop
  //     const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight
  //     if (scrollPosition >= scrollHeight - 1) {
  //       getDataList();
  //     }
  //   }
  //   window.addEventListener('scroll', handleScroll)

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll)
  //   }
  // }, [dataList])


  const getDataList = async (item) => {
    try {
      // if (isLoading || isListEnd) {
      //   return;
      // }

      setIsLoading(true)
      const params = {
        page: page,
        company_name: item?.companyName || '',
        company_number: item?.companyNumber || '',
      }
      const rs = await getContractCompanyForTreatmentList(params);

      if (rs.data?.data) {
        setListCount(rs.data?.data?.length)
        const content = rs.data?.data
        const new_list = [...content]
        setDataList(new_list)
        if (new_list.length >= rs.data.count) {
          setIsListEnd(true)
        }

      }
      setIsLoading(false)
    } catch (e) {
      setIsLoading(false)
    }
  }

  const changePartialContract = async () => {
    if (isLoading)
      return

    setIsLoading(true)
    try {
      const params = {
        contract : selectedCompany?.contract?.id,
        price_per_kg: inputItem?.pricePerKg || selectedCompany?.contract?.price_per_kg,
        memo: inputItem?.memo || selectedCompany?.contract?.memo
      }
      const response = await updateContractDataForTreatment(params)
      if (response?.data?.result === 'success') {
        modalClose('edit')
        setSelectedCompany(null)
        setDataList(prev => prev.map(item =>
          item.id === selectedCompany?.contract?.id ? {
            ...item, contract: {
              ...item.contract,
              price_per_kg: inputItem?.pricePerKg ?? item.contract.price_per_kg,
              memo: inputItem?.memo ?? item.contract.memo,
            },
          } : item
        ))
      } else {
        alert(response?.data?.msg)
      }
      setIsLoading(false)
    } catch (error) {
      alert('오류가 발생하였습니다.')
      console.error(error);
      setIsLoading(false)
    }
  }

  const getCarDataList = async () => {
    try {
      const response = await getCarList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setCarData([...content])
        } else {
          setCarData([])
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const resetSearchCondition = () => {
    setSearchCondition(initSearchCondition)
  }

  const changeSearchCondition = (key, value) => {
    setSearchCondition(prev => ({ ...prev, [key]: value }))
  }

  const deleteClient = async () => {
    const params = {
      company: selectedCompany?.company?.id,
      contract: selectedCompany?.contract?.id,

    }
    const rs = await deleteClientData(params)
    if (rs?.data?.result === 'success') {
      alert('정상적으로 삭제되었습니다.')
      modalClose('delete')
    }
    modalClose('delete')

  }

  const uploadExcelFile = async () => {
    if (onUpload) {
      return
    }
    setOnUpload(true)
    if (excelFile == undefined || excelFile?.length == 0) { setOnUpload(false); return alert('파일을 등록하세요.') }
    try {
      const params = {
        type: 'xlsx',
        category: 'correspondentFile',
        company_id: companyId,
        member_id: myId
      }
      const fd = new FormData();
      fd.append('data', JSON.stringify(params));
      const newFile = new File([excelFile?.[0]], `${encodeURI(excelFile?.[0]?.name)}`, { type: excelFile?.[0]?.type })
      if (excelFile && !_.isEmpty(excelFile)) {
        fd.append('file_0', newFile);
      }

      const response = await console.log(fd)
      if (response?.data?.result === 'success') {
        alert('정상적으로 등록되었습니다.')
      }

    } catch (e) {
      console.log(e)
    }
    setExcelFile([])
    setOnUpload(false)
  }

  const excelDownload = async () => {
    const table = document.getElementById('excel-table');
    if (!table) return;

    const rows = table.querySelectorAll('tr');
    const data = [];

    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i].querySelectorAll('td, th');
      const rowData = [];

      for (let j = 0; j < cells.length; j++) {
        rowData.push(cells[j].innerText);
      }

      data.push(rowData);
    }

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob = new Blob(
      [wbout],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${'거래처 목록'}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }

  const onSearch = async () => {
    getDataList(searchCondition)
  }

  const sampleDownload = async () => {
    const params = {

    }
    const rs = await console.log(params)
    console.log(rs)
  }

  const dateChange = async (date, item) => {

    const response = await changeContractSettlement(item.contract, date)
    if (response.status === 200) {
      getDataList()
    } else {
      alert('정산날짜 변경에 실패하였습니다.')
    }

  }

  const registFiles = (e) => {
    setExcelFile([...e.target.files])
  }

  const makeCodeArr = (str, callback) => {
    let codes = code.filter(itm => itm.code == str)
    let tmp = []
    for (let i = 0; i < codes.length; i++) {
      let itm = {
        id: codes[i]?.key,
        name: codes[i]?.text
      }
      tmp.push(itm)
    }
    callback(tmp)
  }

  useEffect(() => {
    getCarDataList()
    getDataList()
    makeCodeArr('client_type', setCorrespondentSize)
  }, [])

  return (
    <React.Fragment>

      <div className="d-flex w-100 gap-30 align-items-center">
        <div className="email-rightbar flex-grow-1">
          <Card className="mb-0">
            <CardBody className="padding-0">
              <table className="input-table">
                <tbody>
                  <tr>
                    <td className="col-10 padding-left-8 primary-bg white-text">상호명</td>
                    <td className="col-20">
                      <input className="is-touched is-dirty av-valid form-control font-size-14 w-80 border-radius-0" placeholder="상호명 입력" value={searchCondition.companyName} onChange={(e) => {
                        changeSearchCondition('companyName', e.target.value)
                      }} />
                    </td>
                    <td className="col-10 padding-left-8 primary-bg white-text">사업자번호</td>
                    <td className="col-20">
                      <input className="is-touched is-dirty av-valid form-control font-size-14 w-80 border-radius-0" placeholder="사업자 번호 입력" value={searchCondition.businessNumber} onChange={(e) => {
                        changeSearchCondition('companyNumber', e.target.value)
                      }} />
                    </td>
                    <td className="col-10 padding-left-8 primary-bg white-text"></td>
                    <td className="col-20"></td>
                  </tr>
                </tbody>
              </table>
            </CardBody>
          </Card>
        </div>
        <div className="d-flex flex-direction-column align-items-end">
          <button type="button" className="custom-btn btn-dark-gradient margin-bottom-8 border-radius-0 white-text border-none margin-right-0" onClick={() => {
            onSearch()
          }}>
            검색
          </button>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-2 margin-top-25">
        <p className="mb-0 font-size-16"><span className="font-weight-bold">거래처 목록</span> [ 건수 : {dataList.length}건 ]</p>
        <div className="waver-pagination-btn-group" >
          <button style={{ width: 143 }} className="custom-btn success-bg border-radius-0 white-text border-none margin-right-0"
            onClick={() => {
              excelDownload()
            }} >
            엑셀 다운로드
          </button>
        </div>
      </div>
      <Row>
        <Col xs="12">
          <div className="email-rightbar mb-3">

            <Card>
              <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
                <div className="table-responsive">
                  <table id="excel-table" className="table table-hover table-centered table-nowrap mb-0 chart-table">
                    <thead className="chart-thead">
                      <tr>
                        <th scope="col">No</th>
                        <th scope="col">사업자 번호</th>
                        <th scope="col">상호</th>
                        <th scope="col">대표자명</th>
                        <th scope="col">전화번호</th>
                        <th scope="col">휴대폰 번호</th>
                        <th scope="col">이메일</th>
                        <th scope="col">계약일자</th>
                        <th scope="col">단가(원)</th>
                        <th scope="col">수정</th>
                      </tr>
                    </thead>
                    <tbody className="chart-tbody">
                      {dataList.map((item, index) => {
                        return (
                          <tr key={item.id + '_' + index}>
                            <td>{dataList.length - index}</td>
                            <td>{item?.company?.company_number}</td>
                            <td>{item?.company?.name}</td>
                            <td>{item?.company?.username}</td>
                            <td>{item?.company?.phone}</td>
                            <td>{item?.company?.mobile_phone}</td>
                            <td>{item?.company?.email}</td>
                            <td>{moment(item?.contract?.updated_at).format('YYYY-MM-DD')}</td>
                            <td>{moment(item?.contract?.start_date).format('YYYY-MM-DD')} ~ {moment(item?.contract?.end_date).format('YYYY-MM-DD')}</td>
                            <td>
                              <button style={{width: 80}} type="button" size="sm" className="custom-btn border-radius-0 margin-right-4 font-size-15 line-height-1 secondary-bg white-text border-none" onClick={(e) => {
                                e.stopPropagation()
                                modalOpen('edit')
                                setSelectedCompany(item)
                              }}>수정</button>
                            </td>
                          </tr>
                        )
                      })}
                      {dataList.length === 0 &&
                        <tr>
                          <td scope="row" colSpan="14">데이터가 없습니다.</td>
                        </tr>
                      }

                    </tbody>
                  </table>
                </div>
              </CardBody>
              {isLoading && <div style={{
                position: "absolute",
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                background: 'rgba(255, 255, 255, 0.6)',
                zIndex: 999,
                display: "flex",
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <img src={loading} alt="로딩중입니다." width={'3%'}></img>
              </div>}
            </Card>

          </div>
        </Col>
      </Row>

      <Modal
        title={'거래처 정보 수정'}
        show={modalShow.edit}
        onHide={() => {
          modalClose('edit')
          setSelectedCompany(null)
        }}
        size="lg"
        bodyChildren={
          <Fragment>
            <table className="input-table">
              <tbody>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">사업자번호</td>
                  <td className="w-35">
                    {selectedCompany?.company?.company_number}
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">상호</td>
                  <td className="w-35">
                    {selectedCompany?.company?.name}
                  </td>
                </tr>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">Kg단가</td>
                  <td className="w-35">
                    <input className='waver-input-box w-100 border-radius-0' value={inputItem?.pricePerKg || selectedCompany?.contract?.price_per_kg} placeholder="인계량을 입력해 주세요." onChange={(e) => {
                      changeInputCondition('pricePerKg', e.target.value)
                    }} />
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12"></td>
                  <td className="w-35"></td>                  
                </tr>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text">메모</td>
                  <td colSpan="3" className="w-85 pb-0">
                    <textarea className="waver-text-box w-100 font-size-12 border-radius-0" value={inputItem?.memo || selectedCompany?.contract?.memo}
                    onChange={(e)=>{
                      changeInputCondition('memo', e.target.value);
                    }} />
                  </td>
                </tr>
              </tbody>
            </table>
          </Fragment>
        }
        footerChildren={
        <div className="d-flex justify-content-end w-100">
          <div className="d-flex">
            <button style={{width: 59, height: 27}} className="`custom-btn border-radius-0 margin-right-4 font-size-14 line-height-1 secondary-bg white-text border-none" onClick={() => {
              changePartialContract()
            }}>{'확인'}</button>
            <button style={{width: 59, height: 27}} className="custom-btn border-radius-0 font-size-14 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
              setSelectedCompany(null)
              modalClose('edit')
            }}>취소</button>
          </div>
        </div>
        }
      />
    </React.Fragment>
  )
}

export default CorrespondentManagementTreatment
